import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError, LOGO_URL } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const token = params.get("token") || "";

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset! Please sign in.");
      nav("/login");
    } catch (e2) { setErr(formatApiError(e2)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-blue-800 dark:bg-slate-950 flex flex-col" style={{ fontFamily: "'IBM Plex Sans', system-ui, sans-serif" }}>
      <div className="p-4"><Link to="/"><img src={LOGO_URL} alt="logo" className="h-12" /></Link></div>
      <div className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md bg-white dark:bg-slate-900 rounded-3xl shadow-2xl p-8 border border-slate-200 dark:border-slate-800">
          <h1 className="text-2xl font-black text-slate-900 dark:text-white mb-1" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>Set new password</h1>
          <form onSubmit={onSubmit} className="space-y-4 mt-4">
            <input data-testid="reset-password-input" type="password" minLength={6} required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password" className="w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 px-4 py-3 outline-none focus:border-blue-500 text-slate-900 dark:text-slate-100" />
            {err && <div className="text-red-600 text-sm" data-testid="reset-error">{err}</div>}
            <button data-testid="reset-submit-btn" disabled={busy || !token} className="w-full rounded-full bg-blue-700 hover:bg-blue-800 text-white font-bold py-3 disabled:opacity-60">Update password</button>
          </form>
        </div>
      </div>
    </div>
  );
}
